require([
    'jquery',
    'base/MbiHelper',
    'base/MbiImageSize',
    'flickity',
], function(
    $,
    _,
    mbiImageSize,
    Flickity
) {
    'use strict'

/*================================
=            flickity            =
================================*/

    function createFlickity() {

        if ($('.js_flickity').length>0) {
            $('.js_flickity').each(function(index, el) {
                if (el) {
                	var $pageDots = false;
                	var watchCss = false;
                	var $loop = false;
                	var data = $(el).data();
                    var $buttons = false;

                    if($(el).hasClass('arrows')) {
                        $buttons = true;
                    }
                    if($(el).hasClass('loop')) {
                        $loop = true;
                    }
                    if($(el).hasClass('pagination')) {
                        $pageDots = true;
                    }
    	            var flkty = new Flickity( el, {
    	                // options
                        prevNextButtons: $buttons,
    	                cellSelector: '.js_flickity_slide',
    	                contain: true,
                        autoPlay: 7000,
                        pageDots: $pageDots,
    	                wrapAround: $loop
    	            });


                    if($buttons == false) {
                        $(el).find('.js_buttons').find('.prev').on( 'click', function() {
                          flkty.previous();
                        });
                        // next
                        $(el).find('.js_buttons').find('.next').on( 'click', function() {
                          flkty.next();
                        });
                    }
            	}
            });

        }
    }
    if ($('.js_flickity').length) {
        mbiImageSize.init();
        setTimeout(function(){
            createFlickity();
        }, 300);
        createFlickity();
    }
    $(document).on('recreateSlides', function(){
       // console.log('flicktiy');
       if ($('.js_flickity').length) {
            createFlickity();
        }

    });

});
define("root/Assets/Templates/Html/Slideshow/Js/Slideshow", function(){});

